import React from 'react';

import './CategoriesCell.scss';

type Props = {
  value: string;
};

const CategoriesCellView: React.FC<Props> = (props: Props) => {
  return <div className="warpper-categories">{props.value}</div>;
};

CategoriesCellView.displayName = 'CategoriesCellView';

export default CategoriesCellView;
